import React from 'react';
import { motion } from 'framer-motion';

//data
import { PlantNutritionCaseData } from '../../../Data/UseCaseData';
import MetaHead from '@/Components/MetaHead';
import MainHeading from '@/Components/MainHeading';
import SubHeading from '@/Components/SubHeading';
import ContentText from '@/Components/ContentText';
import partnership from '@/assets/usecases/partnership.png';
import Image from 'next/image';
import Link from 'next/link';

export default function PlantNutrition() {
  return (
    <div>
      <MetaHead title="For Plant Nutrition Company | Fyllo" />
      <div className="py-8 px-4 mx-auto max-w-screen-xl text-left lg:py-16 lg:px-6">
        <div className="mx-auto max-w-screen-xl">
          <MainHeading text="For Plant Nutrition" />
          <SubHeading text=" If you are into products for plant nutrition, some of the Fyllo products are just made for you. Features include:" />
        </div>
      </div>

      <div className="pb-10 grid md:grid-cols-2 gap-2 md:gap-10 mx-auto max-w-screen-xl p-5">
        {PlantNutritionCaseData.map((content, i) => {
          if (PlantNutritionCaseData.length - 1 !== i) {
            return (
              <div key={i} className="p-8 md:p-16 bg-slate-200 rounded-lg">
                <div className="text-7xl font-black text-slate-400 ">{`0${i + 1}.`}</div>
                <div className="pt-5">
                  <div className=" text-xl md:text-2xl font-bold text-green-800">{content.title}</div>
                  <ContentText text={content.description} />
                </div>
              </div>
            );
          } else {
            return (
              <Link href={'/contact#contact_form'} key={i} className="relative grid place-items-center rounded-lg">
                <Image
                  className="absolute w-full h-full rounded-lg z-0 brightness-75 "
                  src={partnership}
                  alt="partnership"
                  sizes="(max-width: 768px) 100vw,
              (max-width: 1200px) 50vw,
              33vw"
                />
                <motion.button className="flex justify-center items-center backdrop-blur w-full h-full z-10  text-white text-2xl font-black py-4 px-8 border-green-700  rounded">
                  Explore Partnership With Fyllo
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-10 fill-white stroke-2" viewBox="0 96 960 960">
                    <path d="m375 816-43-43 198-198-198-198 43-43 241 241-241 241Z" />
                  </svg>
                </motion.button>
              </Link>
            );
          }
        })}
      </div>
    </div>
  );
}
